"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instance = void 0;
const instance = (c, x) => x instanceof c;
exports.instance = instance;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5zdGFuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5zdGFuY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sTUFBTSxRQUFRLEdBQUcsQ0FBQyxDQUFNLEVBQUUsQ0FBTSxFQUFpQixFQUFFLENBQUMsQ0FBQyxZQUFZLENBQUMsQ0FBQztBQUE3RCxRQUFBLFFBQVEsWUFBcUQifQ==